<template>
  <div>
    <div>
      <el-dialog
        title="未交班提醒，请及时通知以下电站进行交班填报"
        :visible.sync="dialogVisible"
        width="40%"
        :center="true"
        :before-close="handleClose"
      >
        <div class="queryDate">日期：{{ queryDate }}</div>
        <div class="page-example3" v-show="!type">
          <div class="tableTr">
            <div>电站名称</div>
            <div>班次</div>
            <div>交班人</div>
            <div>电话</div>
          </div>
          <vue-seamless-scroll ref="temperatureScroll" :data="list" :class-option="classOption" class="seamless-warp">
            <ul class="ul-scoll">
              <li class="listData" v-for="(item, index) in list" :key="index">
                <div>{{ item.name }}</div>
                <div>{{ item.teamName }}</div>
                <div>{{ item.shiftUserName }}</div>
                <div>{{ item.phone }}</div>
              </li>
            </ul>
          </vue-seamless-scroll>
        </div>
        <div v-show="type" class="tips">所有电站已完成交班</div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import vueSeamlessScroll from 'vue-seamless-scroll'
export default {
  data() {
    return {
      dialogVisible: false,
      list: [],
      type: true
    }
  },
  mounted() {
    this.initData()
  },
  components: {
    vueSeamlessScroll
  },
  computed: {
    classOption() {
      return {
        step: 0.3,
        limitMoveNum: 10, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: false, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        isSingleRemUnit: true,
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      }
    }
  },
  methods: {
    handleClose() {
      this.dialogVisible = false
    },
    initData() {
      axios.get('/api/powermis/bigScreen/getNoShiftData').then((response) => {
        if (response.data.data.isRemind == 2) {
          this.dialogVisible = true
          if (response.data.data.list.length > 0) {
            this.queryDate = response.data.data.queryDate
            this.list = response.data.data.list
            this.type = false
          } else {
            this.type = true
            setTimeout(function () {
              this.dialogVisible = false
            }, 3000)
          }
        } else {
          this.dialogVisible = false
        }
        console.log(response)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.listData {
  display: flex;
  list-style-type: none;
  align-items: center;
  font-size: 12px;
  background-color: #f5f7fa;
  border-right: 1px solid #ebeef5;
  color: #606266;
  div {
    border-bottom: 1px solid #ebeef5;
    border-right: 1px solid #ebeef5;
    height: 50px;
    line-height: 50px;
    width: 25%;
    text-align: center;
  }
}
.seamless-warp {
  overflow: hidden; /* 多出的隐藏*/
  width: 100%;
  height: 650px;
  ul {
    padding-inline-start: 0px;
  }
}
.queryDate {
  text-align: center;
  margin-bottom: 35px;
}
.tips {
  text-align: center;
  font-size: 16px;
}
.tableTr {
  display: flex;
  list-style-type: none;
  align-items: center;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.85);
  background-color: #fafafa;
  font-weight: 900;
  div {
    height: 50px;
    border-right: 1px solid #ebeef5;
    line-height: 50px;
    width: 25%;
    text-align: center;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/changeShifts.vue